<template>
  <v-dialog
    persistent
    v-model="get_dialogMain.dialog"
    width="800px"
    justify-center
  >
    <v-toolbar dense dark color="blue darken-2">
      <v-toolbar-title>
        <h3 v-if="get_dialogMain.type == 'create'">Nuevo Empresa</h3>
        <h3 v-else>Editar Empresa</h3>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <EmpresaForm
      :model="user"
      :on-success="saveEmpresa"
      :on-cancel="cancel"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import EmpresaForm from '@/components/forms/EmpresaForm'
export default {
  props: ['model'],
  data: () => ({
    user: {}
  }),
  mounted () {
    if (this.model.id) {
      this.user = Object.assign({}, this.model)
    }
  },
  components: {
    EmpresaForm
  },
  methods: {
    ...mapActions(['PutObject']),
    saveEmpresa (model) {
      this.PutObject({ url: `/config/empresas/${model.id}`, data: model })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_DATA'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Empresa ha sido creado'
      })
      this.SET_DATA(val)
      this.cancel()
    }
  }
}
</script>

<style></style>
